import React from 'react';

interface Props {
  width: number;
  height: number;
}

export default (props: Props) => (
  <svg
    {...props}
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_448_2628)">
      <path
        d="M26 43.3334C35.573 43.3334 43.3334 35.573 43.3334 26.0001C43.3334 16.4271 35.573 8.66675 26 8.66675C16.4271 8.66675 8.66669 16.4271 8.66669 26.0001C8.66669 35.573 16.4271 43.3334 26 43.3334Z"
        fill="#e182c395"
      />
      <path
        d="M42.3334 26.0001C42.3334 35.0207 35.0207 42.3334 26 42.3334C16.9794 42.3334 9.66669 35.0207 9.66669 26.0001C9.66669 16.9794 16.9794 9.66675 26 9.66675C35.0207 9.66675 42.3334 16.9794 42.3334 26.0001Z"
        stroke="url(#paint0_linear_448_2628)"
        strokeOpacity="0.1"
        strokeWidth="2"
      />
      <g filter="url(#filter0_di_448_2628)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.3031 21.5511C20.3031 18.3445 23.2613 15.8947 26.6298 16.2356C29.2298 16.5013 31.3618 18.46 31.6564 20.9387C31.8644 22.6605 31.2058 24.0587 29.8422 25.4396L29.5418 25.7342C28.4498 26.7627 27.6004 28.1205 27.4675 29.1547L27.4502 29.4262V29.8076C27.4502 30.6049 26.8031 31.252 26.0058 31.252C25.272 31.252 24.6711 30.7089 24.5729 30.004L24.5613 29.8076V29.4262C24.5613 27.5369 25.6822 25.532 27.2249 23.9605L27.56 23.6311C28.5307 22.7182 28.8831 22.0422 28.7907 21.2796C28.6578 20.1876 27.6293 19.24 26.3409 19.1071C24.7173 18.9453 23.3538 19.9853 23.2093 21.3142L23.1978 21.5511C23.1978 22.3485 22.5507 22.9956 21.7533 22.9956C20.956 22.9956 20.3089 22.3485 20.3089 21.5511H20.3031ZM26 32.2805C24.9542 32.2805 24.0991 33.1298 24.0991 34.1813C24.0991 35.2329 24.9484 36.0822 26 36.0822C27.0515 36.0822 27.9009 35.2329 27.9009 34.1813C27.9009 33.1298 27.0515 32.2805 26 32.2805Z"
          fill="url(#paint1_linear_448_2628)"
          shapeRendering="crispEdges"
        />
        <path
          d="M31.1599 20.9977L31.16 20.9986C31.3441 22.5219 30.7812 23.776 29.4892 25.0854L29.1952 25.3738C28.6197 25.9165 28.1072 26.5461 27.7185 27.1813C27.3325 27.8122 27.0503 28.4785 26.9716 29.091L26.9696 29.1068L26.9686 29.1228L26.9512 29.3944L26.9502 29.4103V29.4262V29.8076C26.9502 30.3288 26.527 30.752 26.0058 30.752C25.5327 30.752 25.1427 30.4069 25.0707 29.9527L25.0613 29.7929V29.4262C25.0613 27.7215 26.0846 25.837 27.5786 24.3139L27.9066 23.9915C28.908 23.0488 29.4089 22.2246 29.287 21.2194L29.287 21.2192C29.1214 19.8584 27.8735 18.7625 26.3922 18.6098L26.3905 18.6096C24.5476 18.426 22.8919 19.6078 22.7123 21.2602L22.7106 21.275L22.7099 21.2899L22.6984 21.5268L22.6978 21.5389V21.5511C22.6978 22.0723 22.2745 22.4956 21.7533 22.4956C21.2321 22.4956 20.8089 22.0723 20.8089 21.5511V21.3199C20.9472 18.558 23.5507 16.4266 26.5792 16.733C28.9702 16.9775 30.8956 18.7746 31.1599 20.9977ZM24.5991 34.1813C24.5991 33.4069 25.2294 32.7805 26 32.7805C26.7754 32.7805 27.4009 33.4059 27.4009 34.1813C27.4009 34.9568 26.7754 35.5822 26 35.5822C25.2246 35.5822 24.5991 34.9568 24.5991 34.1813Z"
          stroke="url(#paint2_linear_448_2628)"
          strokeOpacity="0.1"
          strokeLinecap="round"
          shapeRendering="crispEdges"
        />
      </g>
    </g>
    <mask id="path-5-inside-1_448_2628" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.562 32.5301C43.562 29.1367 40.8036 26.3732 37.4051 26.3732C34.0117 26.3732 31.2483 29.1367 31.2483 32.5301C31.2483 35.9235 34.0117 38.6869 37.4051 38.6869C40.7985 38.6869 43.562 35.9235 43.562 32.5301ZM28.7083 32.5301C28.7083 27.7296 32.5995 23.8333 37.4051 23.8333C42.2057 23.8333 46.102 27.7296 46.102 32.5301C46.102 34.4739 45.4631 36.2695 44.3841 37.7182C44.4084 37.7391 44.4321 37.761 44.4552 37.7841L50.003 43.3319C50.499 43.8279 50.499 44.632 50.003 45.1279C49.5071 45.6239 48.7029 45.6239 48.207 45.1279L42.6591 39.5801C42.6361 39.5571 42.6141 39.5333 42.5932 39.509C41.1445 40.5881 39.349 41.2269 37.4051 41.2269C32.6046 41.2269 28.7083 37.3306 28.7083 32.5301Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.562 32.5301C43.562 29.1367 40.8036 26.3732 37.4051 26.3732C34.0117 26.3732 31.2483 29.1367 31.2483 32.5301C31.2483 35.9235 34.0117 38.6869 37.4051 38.6869C40.7985 38.6869 43.562 35.9235 43.562 32.5301ZM28.7083 32.5301C28.7083 27.7296 32.5995 23.8333 37.4051 23.8333C42.2057 23.8333 46.102 27.7296 46.102 32.5301C46.102 34.4739 45.4631 36.2695 44.3841 37.7182C44.4084 37.7391 44.4321 37.761 44.4552 37.7841L50.003 43.3319C50.499 43.8279 50.499 44.632 50.003 45.1279C49.5071 45.6239 48.7029 45.6239 48.207 45.1279L42.6591 39.5801C42.6361 39.5571 42.6141 39.5333 42.5932 39.509C41.1445 40.5881 39.349 41.2269 37.4051 41.2269C32.6046 41.2269 28.7083 37.3306 28.7083 32.5301Z"
      fill="#e182c395"
    />
    <path
      d="M44.3841 37.7182L43.5821 37.1208L43.0251 37.8686L43.7322 38.4764L44.3841 37.7182ZM44.4552 37.7841L45.1623 37.077L44.4552 37.7841ZM50.003 43.3319L49.2959 44.039H49.2959L50.003 43.3319ZM50.003 45.1279L49.2959 44.4208L49.2959 44.4208L50.003 45.1279ZM48.207 45.1279L48.9141 44.4208V44.4208L48.207 45.1279ZM42.6591 39.5801L41.952 40.2872L42.6591 39.5801ZM42.5932 39.509L43.3515 38.8571L42.7436 38.1501L41.9959 38.707L42.5932 39.509ZM37.4051 27.3732C40.2508 27.3732 42.562 29.6884 42.562 32.5301H44.562C44.562 28.5849 41.3564 25.3732 37.4051 25.3732V27.3732ZM32.2483 32.5301C32.2483 29.689 34.564 27.3732 37.4051 27.3732V25.3732C33.4595 25.3732 30.2483 28.5844 30.2483 32.5301H32.2483ZM37.4051 37.6869C34.564 37.6869 32.2483 35.3712 32.2483 32.5301H30.2483C30.2483 36.4757 33.4595 39.6869 37.4051 39.6869V37.6869ZM42.562 32.5301C42.562 35.3712 40.2462 37.6869 37.4051 37.6869V39.6869C41.3508 39.6869 44.562 36.4757 44.562 32.5301H42.562ZM37.4051 22.8333C32.0469 22.8333 27.7083 27.1776 27.7083 32.5301H29.7083C29.7083 28.2815 33.1522 24.8333 37.4051 24.8333V22.8333ZM47.102 32.5301C47.102 27.1773 42.7579 22.8333 37.4051 22.8333V24.8333C41.6534 24.8333 45.102 28.2818 45.102 32.5301H47.102ZM45.1861 38.3155C46.3891 36.7003 47.102 34.6966 47.102 32.5301H45.102C45.102 34.2512 44.5371 35.8387 43.5821 37.1208L45.1861 38.3155ZM43.7322 38.4764C43.7375 38.481 43.7428 38.4859 43.7481 38.4912L45.1623 37.077C45.1214 37.0361 45.0793 36.9971 45.036 36.9599L43.7322 38.4764ZM43.7481 38.4912L49.2959 44.039L50.7101 42.6248L45.1623 37.077L43.7481 38.4912ZM49.2959 44.039C49.4013 44.1445 49.4013 44.3154 49.2959 44.4208L50.7101 45.8351C51.5966 44.9486 51.5966 43.5113 50.7101 42.6248L49.2959 44.039ZM49.2959 44.4208C49.1905 44.5263 49.0195 44.5263 48.9141 44.4208L47.4999 45.8351C48.3864 46.7215 49.8236 46.7215 50.7101 45.8351L49.2959 44.4208ZM48.9141 44.4208L43.3663 38.873L41.952 40.2872L47.4999 45.8351L48.9141 44.4208ZM43.3663 38.873C43.361 38.8678 43.3561 38.8625 43.3515 38.8571L41.8349 40.1609C41.8721 40.2042 41.9112 40.2464 41.952 40.2872L43.3663 38.873ZM37.4051 42.2269C39.5717 42.2269 41.5754 41.5141 43.1906 40.311L41.9959 38.707C40.7137 39.662 39.1263 40.2269 37.4051 40.2269V42.2269ZM27.7083 32.5301C27.7083 37.8829 32.0523 42.2269 37.4051 42.2269V40.2269C33.1569 40.2269 29.7083 36.7783 29.7083 32.5301H27.7083Z"
      fill="url(#paint3_linear_448_2628)"
      fillOpacity="0.1"
      mask="url(#path-5-inside-1_448_2628)"
    />
    <g opacity="0.7" filter="url(#filter1_di_448_2628)">
      <path
        d="M43.5621 32.5302C43.5621 29.1368 40.8037 26.3733 37.4053 26.3733C34.0119 26.3733 31.2484 29.1368 31.2484 32.5302C31.2484 35.9235 34.0119 38.687 37.4053 38.687C40.7987 38.687 43.5621 35.9235 43.5621 32.5302Z"
        fill="url(#paint4_linear_448_2628)"
        shapeRendering="crispEdges"
      />
      <path
        d="M37.4053 26.8733C40.5273 26.8733 43.0621 29.4126 43.0621 32.5302C43.0621 35.6474 40.5225 38.187 37.4053 38.187C34.288 38.187 31.7484 35.6474 31.7484 32.5302C31.7484 29.4129 34.288 26.8733 37.4053 26.8733Z"
        stroke="url(#paint5_linear_448_2628)"
        strokeOpacity="0.1"
        strokeLinecap="round"
        shapeRendering="crispEdges"
      />
    </g>
    <defs>
      <filter
        id="filter0_di_448_2628"
        x="20.3031"
        y="16.2039"
        width="11.3911"
        height="20.8784"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_448_2628"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_448_2628"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_448_2628"
        />
      </filter>
      <filter
        id="filter1_di_448_2628"
        x="31.2484"
        y="26.3733"
        width="12.3137"
        height="13.3137"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_448_2628"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_448_2628"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_448_2628"
        />
      </filter>
      <linearGradient
        id="paint0_linear_448_2628"
        x1="26"
        y1="8.66675"
        x2="26"
        y2="43.3334"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_448_2628"
        x1="25.9986"
        y1="16.2039"
        x2="25.9986"
        y2="36.0822"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.9" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_448_2628"
        x1="25.9986"
        y1="16.2039"
        x2="25.9986"
        y2="36.0822"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_448_2628"
        x1="39.5416"
        y1="23.8333"
        x2="39.5416"
        y2="45.4999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_448_2628"
        x1="37.4053"
        y1="26.3733"
        x2="37.4053"
        y2="38.687"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.9" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_448_2628"
        x1="37.4053"
        y1="26.3733"
        x2="37.4053"
        y2="38.687"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clip0_448_2628">
        <rect
          width="34.6667"
          height="34.6667"
          fill="white"
          transform="translate(8.66669 8.66675)"
        />
      </clipPath>
    </defs>
  </svg>
);
